import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import FeedBackConstant from "../Constants/FeedBackConstants";
let result = [];

class FeedBackStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getResult() {
    return result;
  }
  setResult(_value) {
    result = _value;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS:
        this.setResult(action.result);
        break;
      case FeedBackConstant.GET_FEEDBACK_LIST_FAILURE:
        this.setResult(action.result);
        break;
      case FeedBackConstant.SAVE_UPDATE_FEEDBACK_SUCCESS:
        this.setResult(action.result);
        break;
      case FeedBackConstant.SAVE_UPDATE_FEEDBACK_FAILURE:
        this.setResult(action.result);
        break;
      case FeedBackConstant.DEL_FEEDBACK_SUCCESS:
        this.setResult(action.result);
        break;
      case FeedBackConstant.DEL_FEEDBACK_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const feedBackStore = new FeedBackStore();
dispatcher.register(feedBackStore.handleCallback.bind(feedBackStore));
export default feedBackStore;
